import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCanOrganicsStyle0 = gravityIconIndividualCss;

const GravityIconCanOrganics = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '47b444dd11b3205d2fd6654e4419bfdbe048af6b', color: this.color, size: this.size }, h("svg", { key: '8a34d6b976c9a95821093942fe6e216e098cc054', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'ab6ffb173d515f9e07698f527ff5cf350486da3e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2.5c2.523 0 4.5 1.222 4.5 3v11.644c0 1.546-2.264 2.356-4.5 2.356s-4.5-.81-4.5-2.356V5.5c0-1.778 1.977-3 4.5-3Zm-3 13v1.644c1 .856 4.5 1.356 6 0V9.5c-.04.799-1.133 1.686-2.824 2.777-1.692 1.09-3.137 2.432-3.176 3.222Zm6-10c0-.827-1.346-1.5-3-1.5s-3 .673-3 1.5C8 6.127 9.141 7 11 7s3-.873 3-1.5Z", fill: "currentColor" }))));
    }
};
GravityIconCanOrganics.style = GravityIconCanOrganicsStyle0;

export { GravityIconCanOrganics as gravity_icon_can_organics };

//# sourceMappingURL=gravity-icon-can-organics.entry.js.map